export const initialRoutes = [
    {
        path: '/min-side',
        name: 'home',
        meta: { requiresAuth: true },
        component: () => import('../pages/HomePage.vue')
    },
    {
        path: '/min-side/arrangementer',
        name: 'my-events',
        meta: { requiresAuth: true },
        component: () => import('../pages/events/MyEventsPage.vue')

    },
    {
        path: '/min-side/mine-arrangementer/opret-arrangement',
        name: 'create-event',
        meta: { requiresAuth: true },
        component: () => import('../pages/events/create-event/CreateEventPage.vue'),
        children: [
            {
                path: '',
                name: 'createEventStep1',
                component: () => import('../pages/events/create-event/CreateEventPageStep1.vue')
            },
            {
                path: 'detaljer',
                name: 'createEventStep2',
                component: () => import('../pages/events/create-event/CreateEventPageStep2.vue')
            },
            {
                path: 'godkend',
                name: 'createEventStep3',
                component: () => import('../pages/events/create-event/CreateEventPageStep3.vue')
            }
        ]
    },
    {
        path: '/min-side/kvittering',
        name: 'event-created',
        meta: { useTransparentLayout: false, requiresAuth: false },
        component: () => import('../pages/events/EventCreateSuccesPage.vue')
    },

    // Profile pages
    {
        path: '/min-side/profil',
        name: 'profile',
        meta: { requiresAuth: true },
        component: () => import('../pages/profile/ProfilePage.vue')
    },
    {
        path: '/min-side/profil/rediger-profil',
        name: 'edit-profile',
        meta: { requiresAuth: true },
        component: () => import('../pages/profile/EditProfilePage.vue')
    }, {
        path: '/min-side/profil/rediger-naturfamilie-profil',
        name: 'edit-naturefamily-profile',
        meta: { requiresAuth: true },
        component: () => import('../pages/profile/EditNatureFamilyProfilePage.vue')
    },
    {
        path: '/min-side/profil/administrer-arrangoerer',
        name: 'edit-organizers',
        meta: { requiresAuth: true },
        component: () => import('../pages/profile/EditOrganizersPage.vue')
    },
    {
        path: '/min-side/profil/rediger-naturfamilie-profil',
        name: 'naturefamily-profile',
        meta: { requiresAuth: true },
        component: () => import('../pages/profile/EditNatureFamilyProfilePage.vue')
    },
    {
        path: '/signin',
        name: 'signin',
        meta: { requiresAuth: true },
        component: () => import('../pages/profile/EditProfilePage.vue')
    },
    {
        path: '/',
        name: 'events-search',
        meta: { requiresAuth: false },
        component: () => import('../pages/event/EventSearchPage.vue')
    },
    {
        path: '/ophavsret',
        name: 'copyright',
        meta: { requiresAuth: false},
        component: () => import('../pages/Copyright.vue')
    },
    {
        path: '/changelog',
        name: 'changelog',
        meta: { requiresAuth: false},
        component: () => import('../pages/ChangeLog.vue')
    },

    // Event pages
    {
        path: '/arrangementer',
        name: 'events',
        meta: { requiresAuth: false},
        component: () => import('../pages/event/EventsPage.vue'),
        alias: '/',
        children: [
            {
                path: '',
                name: 'events-overview',
                meta: { requiresAuth: false},
                component: () => import('../pages/event/EventSearchPage.vue')
            },
            {
                path: ':id',
                name: 'event-page',
                props: true,
                meta: { requiresAuth: false},
                component: () => import('../pages/event/EventPage.vue')
            }
        ]
    },

    // Create user pages
    {
        path: '/min-side/opret-bruger',
        name: 'createUser',
        component: () => import('../pages/create-user/CreateUser.vue'),
        meta: {
            layout: 'EmptyLayout'
        },
        children: [
            {
                path: '',
                name: 'yourLogin',
                component: () => import('../pages/create-user/YourLoginPage.vue')
            },
            {
                path: 'dine-grupper',
                name: 'yourGroups',
                component: () => import('../pages/create-user/YourGroupsPage.vue')
            },
            {
                path: 'dine-oplysninger',
                name: 'yourProfile',
                component: () => import('../pages/create-user/YourProfilePage.vue')
            }
        ]
    },

    // Not found 404 page
    {
        path: '/:pathMatch(.*)*',
        name: 'notFound',
        component: () => import('../pages/NotFoundPage.vue')
    }
]